import { ref } from 'vue'

export const useDatePicker = formData => {
  const showDatePicker = ref(false)

  const formatDateTime = date => {
    var y = date.getFullYear()
    var m = date.getMonth() + 1 //注意这个“+1”
    m = m < 10 ? '0' + m : m
    var d = date.getDate()
    d = d < 10 ? '0' + d : d
    var h = date.getHours()
    h = h < 10 ? '0' + h : h
    var minute = date.getMinutes()
    minute = minute < 10 ? '0' + minute : minute
    var second = date.getSeconds()
    second = second < 10 ? '0' + second : second
    return `${y}-${m}-${d}`
  }

  const handleDatePickerConfirmClick = value => {
    formData.birthday = formatDateTime(value)
    showDatePicker.value = false
  }

  return {
    showDatePicker,
    handleDatePickerConfirmClick
  }
}
